module.exports = __webpack_public_path__ + "img/argentina.0ef31383.jpg";